import React from "react";
import "./about.css";
import hotelpic from "../../assets/outsidehotel.png";
import prizrenmap from "../../assets/prizren-map.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationCrosshairs, faPumpSoap, faUsers, faPhone, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";

const About = () => {

    return(
        <div>
            <div id="aboutbanner" className="pagebanner">
                <h1>About us</h1>
            </div>
            <div id="firstabout">
                <div id="abouttext">
                    <h4>About us</h4>
                    <h1>Introduction</h1>
                    <h3>Welcome to AEA Name, a beacon of luxury and hospitality in the heart of Prizren. Established in 2023, our hotel is a testament to timeless elegance and impeccable service. Our dedicated team of professionals is committed to ensuring that your stay is not just memorable but truly exceptional.<br /><br /> From our well-appointed rooms and outstanding amenities to our exquisite dining experiences and prime location near Kalaja e Prizrenit, we invite you to immerse yourself in a world of unparalleled comfort and sophistication. Discover the essence of hospitality at AEA, where every moment is an opportunity to create cherished memories for our valued guests.</h3>
                    <Link to="/gallery"><button>Discover more</button></Link>
                </div>
                <div id="hotelpicture">
                    <img src={hotelpic} alt="" />
                </div>
            </div>
            <div id="secondabout">
                <div id="aboutstaff">
                    <div id="userbox">
                        <FontAwesomeIcon icon={faUsers} className="abouticons"/>
                    </div>
                    <div className="satext">
                        <h2>Friendly staff</h2>
                        <h4>Our hotel staff is always here with a friendly smile to make your stay exceptional. Your comfort is our priority!</h4>
                        <Link to="/gallery"><button>Learn more</button></Link>
                    </div>
                </div>

                <div id="aboutlocation">
                    <div id="locationbox">
                        <FontAwesomeIcon icon={faLocationCrosshairs} className="abouticons" />
                    </div>
                    <div className="satext">
                        <h2>Excellent location</h2>
                        <h4>Our hotel boasts a prime location, putting you in the heart of the action. Explore the city with ease, as all the best attractions are just steps away.</h4>
                        <Link to="/gallery"><button>Learn more</button></Link>
                    </div>
                </div>

                <div id="abouthygiene">
                    <div id="hygienebox">
                        <FontAwesomeIcon icon={faPumpSoap} className="abouticons" />
                    </div>
                    <div className="satext">
                        <h2>Hygienic environment</h2>
                        <h4>Experience impeccable cleanliness at our hotel. We take pride in maintaining spotless rooms and public areas to ensure your stay is both comfortable and hygienic.</h4>
                        <Link to="/gallery"><button>Learn more</button></Link>
                    </div>  
                </div>
            </div>

            <div id="thirdabout">
                <div>
                    <div><FontAwesomeIcon className="contacticons thirdabouticon" icon={faPhone} /><h2>+383 44 233 821</h2></div>
                    <div><FontAwesomeIcon className="contacticons thirdabouticon" icon={faEnvelope}/><h2>info@hotel.com</h2></div>
                    <div><FontAwesomeIcon className="contacticons thirdabouticon" icon={faLocationDot} /><h2>Rr. Filan Festeku p.n</h2></div>
                </div>
                <div>
                    <a href="https://maps.google.com" rel="noreferrer" target="_blank"><img src={prizrenmap} id="prizrenmap" alt="" /></a>
                </div>
            </div>
        </div>
    )
}

export default About